import { Autolinker } from 'autolinker';

import { CopyValue } from '../utils/CopyValue';

export function Reference({
  reference,
  copy,
}: {
  reference: string;
  copy?: boolean;
}) {
  const content = (
    <p
      className="m-0"
      style={{
        fontStyle: 'italic',
        wordBreak: 'keep-all',
        textAlign: 'justify',
      }}
      dangerouslySetInnerHTML={
        reference
          ? {
              __html: Autolinker.link(reference),
            }
          : undefined
      }
    />
  );

  if (!copy) {
    return content;
  }
  return <CopyValue value={reference} renderedValue={content} />;
}
